import React, { useCallback, useEffect } from 'react';
import { Col, Row } from 'antd';

import logo from '../../assets/images/logo-dark.svg';

import '../Payment/Payment.css';

function Plan({ history, location }) {
  useEffect(() => {
    if (!location.state) {
      history.replace('/');
    }
  }, []);

  const onFree = useCallback(() => {
    history.push('/download');
  }, []);

  const onPremium = useCallback(() => {
    history.push('/payment', { ...location.state });
  }, [location]);

  return (
    <div className="AppWrapper">
      <div className="logo">
        <img src={logo} alt="logo" />
      </div>
      <div className="AppContentWrapper">
        <Row>
          <Col span={12} className="gutter-row border-right">
            <h2 className="h2">Free Access</h2>
            <div className="gutter-box">
              <span className="color-white">Ability to create one location and one card</span>

              <button className="SubmitButton" onClick={onFree}>
                Get Free
              </button>
            </div>
          </Col>
          <Col span={12} className="gutter-row">
            <h2 className="h2">Premium Access</h2>
            <div className="gutter-box">
              <span className="color-white">Ability to create up to 10 locations and unlimited cards</span>

              <button className="SubmitButton" onClick={onPremium}>
                Get Premium
              </button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Plan;




// WEBPACK FOOTER //
// ./src/containers/Business/SelectPremium.js